/* eslint-disable import/prefer-default-export */
export const datePickerSymbol = Symbol('datePicker');
